import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import Button from "../Button";

import settings from "../../config";
import Input from "../Input/Input";
import Header from "../Header";

const BillCategoryForm = () => {
  const navigate = useNavigate();
  const { billCategoryId } = useParams();

  const [formData, setFormData] = useState({
    billCategoryName: "",
    seasonId: "",
  });

  useEffect(() => {
    if (billCategoryId) {
      (async () => {
        const response = await axios.post(
          `${settings.api}bill-categories/view`,
          {
            billCategoryId: billCategoryId,
          },
        );

        if (response.data.data) {
          setFormData(response.data.data[0]);
        }
      })();
    }
  }, [billCategoryId]);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <form
      dir="rtl"
      onSubmit={async (e) => {
        e.preventDefault();

        const response = await axios.post(
          `${settings.api}bill-categories/${
            billCategoryId ? "update" : "create"
          }`,
          formData,
        );

        if (response.data.statusCode === 200) {
          navigate("/bill-categories");
        }
      }}
    >
      <div className="w-full">
        <Header title="استماره قسم المدفوعات" />

        <div className="flex flex-col w-full lg:w-1/2 m-auto gap-4">
          <Input
            label="اسم قسم المدفوعات"
            value={formData.billCategoryName}
            onChange={onChange}
            name="billCategoryName"
          />

          <Button
            className="w-1/2 m-auto"
            type="submit"
            text="تسجيل"
            isDisabled={!formData.billCategoryName}
          />
        </div>
      </div>
    </form>
  );
};

export default BillCategoryForm;
